// Only a corporate admin's own org; a carrier login in an org must not edit that org's settings.
export const viewingOrganizationIdOf = (user) => {
    const isCorporateAdmin = !!user.roles.ADMIN && !user.roles.ONWARD_ADMIN;
    if (!isCorporateAdmin) return null;

    return user.organization_id || null;
};
